const setFontFamily = (editor, { value: font }) => {
  const fontFamily = font.includes(' ') ? `'${font}'` : font;
  editor.chain().focus().setMark('textStyle', { fontFamily }).run();
};

export default {
  'font:family': setFontFamily,
};
